import { isDevMode } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

import { HttpLoaderService } from './http-loader.service';
import { ALL_LANGUAGES_LIST, LANGUAGE_CONFIG } from './language-config';

export const provideTranslations = () => {
  // Build availableLangs from centralized config
  const availableLangs = [
    ...ALL_LANGUAGES_LIST,
    // Include debug language if enabled
    ...(LANGUAGE_CONFIG.debugLanguage?.enabled ? [LANGUAGE_CONFIG.debugLanguage.code] : []),
  ];

  return [
    provideTransloco({
      config: {
        availableLangs,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: false,
          allowEmpty: true,
          // Enable logging in dev mode to catch missing translations
          logMissingKey: isDevMode(),
        },
      },
      loader: HttpLoaderService,
    }),
    provideTranslocoMessageformat(),
    provideTranslocoLocale(),
  ];
};
